import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import isMobile from 'is-mobile';

export interface IFTUEPopupControllerOptions {
    text: string
}

export class FTUEPopupController extends AnimationBaseController {
    $model: any;
    constructor (
        @Inject private options: IFTUEPopupControllerOptions,
    ) {
        super('FTUEPopupController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: isMobile() ? AnimationContents.GAME_SCREEN_MOBILE_JSON : AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'ftue_popup',
        }
    }

    protected onInitialize(): void {
        this.setTextByQuery('txt_content', this.options.text);
    }
}
